import { SUPPORT } from "./types";

export const loadSupportFaq = () => ({
  type: SUPPORT.LOAD_SUPPORT_FAQS
});

export const loadSupportFaqSuccess = (list) => (
 {
  type: SUPPORT.LOAD_SUPPORT_FAQS_SUCCESS,
  list,
});

export const loadSupportFaqFailure = (error) => ({
  type: SUPPORT.LOAD_SUPPORT_FAQS_FAILURE,
  error
});

export const loadUnauthenticatedSupportFaq = () => ({
  type: SUPPORT.LOAD_UNAUTHENTICATED_SUPPORT_FAQS
});

export const loadUnauthenticatedSupportFaqSuccess = (list) => (
 {
  type: SUPPORT.LOAD_UNAUTHENTICATED_SUPPORT_FAQS_SUCCESS,
  list,
});

export const loadUnauthenticatedSupportFaqFailure = (error) => ({
  type: SUPPORT.LOAD_UNAUTHENTICATED_SUPPORT_FAQS_FAILURE,
  error
});

export const loadGeoIPCountry = () => ({
  type: SUPPORT.LOAD_GEO_IP_COUNTRY
});

export const loadGeoIPCountrySuccess = (list) => (
 {
  type: SUPPORT.LOAD_GEO_IP_COUNTRY_SUCCESS,
  list,
});

export const loadGeoIPCountryFailure = (error) => ({
  type: SUPPORT.LOAD_GEO_IP_COUNTRY_FAILURE,
  error
});

export const fetchCountry = () => ({
  type: SUPPORT.LOAD_GET_COUNTRIES
});

export const fetchCountrySuccess = (list) => (
 {
  type: SUPPORT.LOAD_GET_COUNTRIES_SUCCESS,
  list,
});

export const fetchCountryFailure = (error) => ({
  type: SUPPORT.LOAD_GET_COUNTRIES_FAILURE,
  error
});

export const loadProductUpdate = (language) => ({
  type: SUPPORT.LOAD_PRODUCT_UPDATE,
  language,
});

export const loadProductUpdateSuccess = (list) => (
{
  type: SUPPORT.LOAD_PRODUCT_UPDATE_SUCCESS, 
  list,
});

export const loadProductUpdateFailure = (error) => ({
  type: SUPPORT.LOAD_PRODUCT_UPDATE_FAILURE,
  error
});

export const handleDownloadModal = (stage) => ({
  type: SUPPORT.LOAD_DOWNLOAD_MODAL,
  stage
});

export const handleDownloadUrl = (url) => ({
  type: SUPPORT.LOAD_DOWNLOAD_URL,
  url
});